import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';

import LogRocket from 'logrocket';

import { ChildrenPropType } from '../../utils/proptypes';
import { useRecaptcha } from '../RecaptchaProvider/RecaptchaProvider.hooks';

import './RecaptchaForm.css';

const propTypes = {
  onSubmit: PropTypes.func.isRequired,
  children: ChildrenPropType.isRequired,
  className: PropTypes.string,
  success: PropTypes.bool,
  size: PropTypes.string,
  action: PropTypes.string.isRequired,
};

const defaultProps = {
  className: '',
  success: false,
  size: null,
};

export default function RecaptchaForm({ onSubmit, children, className, success, size, action }) {
  const [submitting, setSubmitting] = useState(false);
  const [executeRecaptcha, recaptchaLoaded] = useRecaptcha();

  async function handleSubmit(event) {
    try {
      setSubmitting(true);
      const token = await executeRecaptcha(action);
      await onSubmit(event, token);
      setSubmitting(false);
    } catch (e) {
      setSubmitting(false);
      LogRocket.captureException(e);
    }
  }

  return (
    <Form
      className={`recaptcha-form ${className}`}
      onSubmit={handleSubmit}
      success={success}
      size={size}
      loading={!recaptchaLoaded}
    >
      {typeof children === 'function' ? children({ submitting }) : children}
    </Form>
  );
}

RecaptchaForm.propTypes = propTypes;
RecaptchaForm.defaultProps = defaultProps;
